export default "__VITE_ASSET__BHhHY2NI__"